<template>
  <div>
    <common-dialog ref="dialog" width="800px" unit="工艺数据" id-key="RecordId" :data="data" :get-data-func="api.info" :line-form="true" form-label-width="150px" @details-opened="onEditOpened">
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="订单号" prop="OrderNo">
              {{ data.OrderNo }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工单号" prop="WorkDocNo">
              {{ data.WorkDocNo }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生产产品名称" prop="ProductName">
              {{ data.ProductName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="使用模具名称" prop="MouldName">
              {{ data.MouldName }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="设定温度1" prop="Ts1">
              {{ data.Ts1 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设定温度2" prop="Ts2">
              {{ data.Ts2 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设定温度3" prop="Ts3">
              {{ data.Ts3 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设定温度4" prop="Ts4">
              {{ data.Ts4 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设定温度5" prop="Ts5">
              {{ data.Ts5 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设定温度6" prop="Ts6">
              {{ data.Ts6 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="设定温度7" prop="Ts7">
              {{ data.Ts7 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设定温度8" prop="Ts8">
              {{ data.Ts8 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设定温度9" prop="Ts9">
              {{ data.Ts9 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设定温度10" prop="Ts10">
              {{ data.Ts10 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注射压力1" prop="Ip1">
              {{ data.Ip1 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="注射压力2" prop="Ip2">
              {{ data.Ip2 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注射压力3" prop="Ip3">
              {{ data.Ip3 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注射压力4" prop="Ip4">
              {{ data.Ip4 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注射压力5" prop="Ip5">
              {{ data.Ip5 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注射压力6" prop="Ip6">
              {{ data.Ip6 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注射压力7" prop="Ip7">
              {{ data.Ip7 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="注射压力8" prop="Ip8">
              {{ data.Ip8 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注射压力9" prop="Ip9">
              {{ data.Ip9 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注射压力10" prop="Ip10">
              {{ data.Ip10 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="注射速度1" prop="Iv1">
              {{ data.Iv1 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="注射速度2" prop="Iv2">
              {{ data.Iv2 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注射速度3" prop="Iv3">
              {{ data.Iv3 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="注射速度4" prop="Iv4">
              {{ data.Iv4 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="注射速度5" prop="Iv5">
              {{ data.Iv5 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注射速度6" prop="Iv6">
              {{ data.Iv6 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="注射速度7" prop="Iv7">
              {{ data.Iv7 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="注射速度8" prop="Iv8">
              {{ data.Iv8 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注射速度9" prop="Iv9">
              {{ data.Iv9 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="注射速度10" prop="Iv10">
              {{ data.Iv10 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="注射位置1" prop="Is1">
              {{ data.Is1 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="注射位置2" prop="Is2">
              {{ data.Is2 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注射位置3" prop="Is3">
              {{ data.Is3 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="注射位置4" prop="Is4">
              {{ data.Is4 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="注射位置5" prop="Is5">
              {{ data.Is5 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注射位置6" prop="Is6">
              {{ data.Is6 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="注射位置7" prop="Is7">
              {{ data.Is7 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="注射位置8" prop="Is8">
              {{ data.Is8 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注射位置9" prop="Is9">
              {{ data.Is9 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="注射位置10" prop="Is10">
              {{ data.Is10 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="注射时间1" prop="It1">
              {{ data.It1 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="注射时间2" prop="It2">
              {{ data.It2 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注射时间3" prop="It3">
              {{ data.It3 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="注射时间4" prop="It4">
              {{ data.It4 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="注射时间5" prop="It5">
              {{ data.It5 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注射时间6" prop="It6">
              {{ data.It6 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="注射时间7" prop="It7">
              {{ data.It7 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="注射时间8" prop="It8">
              {{ data.It8 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注射时间9" prop="It9">
              {{ data.It9 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="注射时间10" prop="It10">
              {{ data.It10 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="注射按时间" prop="Ituse">
              {{ data.Ituse }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="注射按位置" prop="Isuse">
              {{ data.Isuse }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="保压切换时间" prop="Sipt">
              {{ data.Sipt }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保压切换位置" prop="Sips">
              {{ data.Sips }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="保压切换压力" prop="Sipp">
              {{ data.Sipp }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="保压压力1" prop="Pp1">
              {{ data.Pp1 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="保压压力2" prop="Pp2">
              {{ data.Pp2 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保压压力3" prop="Pp3">
              {{ data.Pp3 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="保压压力4" prop="Pp4">
              {{ data.Pp4 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="保压压力5" prop="Pp5">
              {{ data.Pp5 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保压压力6" prop="Pp6">
              {{ data.Pp6 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="保压压力7" prop="Pp7">
              {{ data.Pp7 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="保压压力8" prop="Pp8">
              {{ data.Pp8 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保压压力9" prop="Pp9">
              {{ data.Pp9 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="保压压力10" prop="Pp10">
              {{ data.Pp10 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="保压速度1" prop="Pv1">
              {{ data.Pv1 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="保压速度2" prop="Pv2">
              {{ data.Pv2 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保压速度3" prop="Pv3">
              {{ data.Pv3 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="保压速度4" prop="Pv4">
              {{ data.Pv4 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="保压速度5" prop="Pv5">
              {{ data.Pv5 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保压速度6" prop="Pv6">
              {{ data.Pv6 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="保压速度7" prop="Pv7">
              {{ data.Pv7 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="保压速度8" prop="Pv8">
              {{ data.Pv8 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保压速度9" prop="Pv9">
              {{ data.Pv9 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="保压速度10" prop="Pv10">
              {{ data.Pv10 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="保压时间1" prop="Pt1">
              {{ data.Pt1 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="保压时间2" prop="Pt2">
              {{ data.Pt2 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保压时间3" prop="Pt3">
              {{ data.Pt3 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="保压时间4" prop="Pt4">
              {{ data.Pt4 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="保压时间5" prop="Pt5">
              {{ data.Pt5 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保压时间6" prop="Pt6">
              {{ data.Pt6 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="保压时间7" prop="Pt7">
              {{ data.Pt7 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="保压时间8" prop="Pt8">
              {{ data.Pt8 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="保压时间9" prop="Pt9">
              {{ data.Pt9 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="保压时间10" prop="Pt10">
              {{ data.Pt10 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="储前射退距离/位置" prop="Sbs1">
              {{ data.Sbs1 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="储前射退时间" prop="Sbt1">
              {{ data.Sbt1 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="储料限时" prop="Pllt">
              {{ data.Pllt }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="储料转速1" prop="Plv1">
              {{ data.Plv1 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="储料转速2" prop="Plv2">
              {{ data.Plv2 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="储料转速3" prop="Plv3">
              {{ data.Plv3 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="储料转速4" prop="Plv4">
              {{ data.Plv4 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="储料转速5" prop="Plv5">
              {{ data.Plv5 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="储料转速6" prop="Plv6">
              {{ data.Plv6 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="储料转速7" prop="Plv7">
              {{ data.Plv7 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="储料转速8" prop="Plv8">
              {{ data.Plv8 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="储料转速9" prop="Plv9">
              {{ data.Plv9 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="储料转速10" prop="Plv10">
              {{ data.Plv10 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="储料压力1" prop="Plp1">
              {{ data.Plp1 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="储料压力2" prop="Plp2">
              {{ data.Plp2 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="储料压力3" prop="Plp3">
              {{ data.Plp3 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="储料压力4" prop="Plp4">
              {{ data.Plp4 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="储料压力5" prop="Plp5">
              {{ data.Plp5 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="储料压力6" prop="Plp6">
              {{ data.Plp6 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="储料压力7" prop="Plp7">
              {{ data.Plp7 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="储料压力8" prop="Plp8">
              {{ data.Plp8 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="储料压力9" prop="Plp9">
              {{ data.Plp9 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="储料压力10" prop="Plp10">
              {{ data.Plp10 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="储料背压1" prop="Plbp1">
              {{ data.Plbp1 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="储料背压2" prop="Plbp2">
              {{ data.Plbp2 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="储料背压3" prop="Plbp3">
              {{ data.Plbp3 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="储料背压4" prop="Plbp4">
              {{ data.Plbp4 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="储料背压5" prop="Plbp5">
              {{ data.Plbp5 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="储料背压6" prop="Plbp6">
              {{ data.Plbp6 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="储料背压7" prop="Plbp7">
              {{ data.Plbp7 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="储料背压8" prop="Plbp8">
              {{ data.Plbp8 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="储料背压9" prop="Plbp9">
              {{ data.Plbp9 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="储料背压10" prop="Plbp10">
              {{ data.Plbp10 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="储料位置1" prop="Pls1">
              {{ data.Pls1 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="储料位置2" prop="Pls2">
              {{ data.Pls2 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="储料位置3" prop="Pls3">
              {{ data.Pls3 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="储料位置4" prop="Pls4">
              {{ data.Pls4 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="储料位置5" prop="Pls5">
              {{ data.Pls5 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="储料位置6" prop="Pls6">
              {{ data.Pls6 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="储料位置7" prop="Pls7">
              {{ data.Pls7 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="储料位置8" prop="Pls8">
              {{ data.Pls8 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="储料位置9" prop="Pls9">
              {{ data.Pls9 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="储料位置10" prop="Pls10">
              {{ data.Pls10 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="射退速度" prop="Sbv2">
              {{ data.Sbv2 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="射退压力" prop="Sbp2">
              {{ data.Sbp2 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="射退距离/位置" prop="Sbs2">
              {{ data.Sbs2 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="射退时间" prop="Sbt2">
              {{ data.Sbt2 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="冷却时间" prop="Ct">
              {{ data.Ct }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="合模速度1" prop="Mcv1">
              {{ data.Mcv1 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="合模速度2" prop="Mcv2">
              {{ data.Mcv2 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合模速度3" prop="Mcv3">
              {{ data.Mcv3 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="合模速度4" prop="Mcv4">
              {{ data.Mcv4 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="合模速度5" prop="Mcv5">
              {{ data.Mcv5 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合模速度6" prop="Mcv6">
              {{ data.Mcv6 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="合模速度7" prop="Mcv7">
              {{ data.Mcv7 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="合模速度8" prop="Mcv8">
              {{ data.Mcv8 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合模速度9" prop="Mcv9">
              {{ data.Mcv9 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="合模速度10" prop="Mcv10">
              {{ data.Mcv10 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="合模位置1" prop="Mcs1">
              {{ data.Mcs1 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="合模位置2" prop="Mcs2">
              {{ data.Mcs2 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合模位置3" prop="Mcs3">
              {{ data.Mcs3 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="合模位置4" prop="Mcs4">
              {{ data.Mcs4 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="合模位置5" prop="Mcs5">
              {{ data.Mcs5 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合模位置6" prop="Mcs6">
              {{ data.Mcs6 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="合模位置7" prop="Mcs7">
              {{ data.Mcs7 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="合模位置8" prop="Mcs8">
              {{ data.Mcs8 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合模位置9" prop="Mcs9">
              {{ data.Mcs9 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="合模位置10" prop="Mcs10">
              {{ data.Mcs10 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="开模速度1" prop="Mov1">
              {{ data.Mov1 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="开模速度2" prop="Mov2">
              {{ data.Mov2 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开模速度3" prop="Mov3">
              {{ data.Mov3 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="开模速度4" prop="Mov4">
              {{ data.Mov4 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="开模速度5" prop="Mov5">
              {{ data.Mov5 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开模速度6" prop="Mov6">
              {{ data.Mov6 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="开模速度7" prop="Mov7">
              {{ data.Mov7 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="开模速度8" prop="Mov8">
              {{ data.Mov8 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开模速度9" prop="Mov9">
              {{ data.Mov9 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="开模速度10" prop="Mov10">
              {{ data.Mov10 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="开模压力1" prop="Mop1">
              {{ data.Mop1 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="开模压力2" prop="Mop2">
              {{ data.Mop2 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开模压力3" prop="Mop3">
              {{ data.Mop3 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="开模压力4" prop="Mop4">
              {{ data.Mop4 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="开模压力5" prop="Mop5">
              {{ data.Mop5 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开模压力6" prop="Mop6">
              {{ data.Mop6 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="开模压力7" prop="Mop7">
              {{ data.Mop7 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="开模压力8" prop="Mop8">
              {{ data.Mop8 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开模压力9" prop="Mop9">
              {{ data.Mop9 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="开模压力10" prop="Mop10">
              {{ data.Mop10 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="开模位置1" prop="Mos1">
              {{ data.Mos1 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="开模位置2" prop="Mos2">
              {{ data.Mos2 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开模位置3" prop="Mos3">
              {{ data.Mos3 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="开模位置4" prop="Mos4">
              {{ data.Mos4 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="开模位置5" prop="Mos5">
              {{ data.Mos5 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开模位置6" prop="Mos6">
              {{ data.Mos6 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="开模位置7" prop="Mos7">
              {{ data.Mos7 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="开模位置8" prop="Mos8">
              {{ data.Mos8 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开模位置9" prop="Mos9">
              {{ data.Mos9 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="开模位置10" prop="Mos10">
              {{ data.Mos10 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="顶进延迟时间" prop="Efdt">
              {{ data.Efdt }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="顶进速度1" prop="Efv1">
              {{ data.Efv1 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="顶进速度2" prop="Efv2">
              {{ data.Efv2 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="顶进速度3" prop="Efv3">
              {{ data.Efv3 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="顶进压力1" prop="Efp1">
              {{ data.Efp1 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="顶进压力2" prop="Efp2">
              {{ data.Efp2 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="顶进压力3" prop="Efp3">
              {{ data.Efp3 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="顶进位置终点1" prop="Efs1">
              {{ data.Efs1 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="顶进位置终点2" prop="Efs2">
              {{ data.Efs2 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="顶进位置终点3" prop="Efs3">
              {{ data.Efs3 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="顶退延迟时间" prop="Ebdt">
              {{ data.Ebdt }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="顶退速度1" prop="Ebv1">
              {{ data.Ebv1 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="顶退速度2" prop="Ebv2">
              {{ data.Ebv2 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="顶退速度3" prop="Ebv3">
              {{ data.Ebv3 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="顶退压力1" prop="Ebp1">
              {{ data.Ebp1 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="顶退压力2" prop="Ebp2">
              {{ data.Ebp2 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="顶退压力3" prop="Ebp3">
              {{ data.Ebp3 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="顶退位置终点1" prop="Ebs1">
              {{ data.Ebs1 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="顶退位置终点2" prop="Ebs2">
              {{ data.Ebs2 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="顶退位置终点3" prop="Ebs3">
              {{ data.Ebs3 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="中子模式1" prop="Cp1m">
              {{ data.Cp1m }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="中子模式2" prop="Cp2m">
              {{ data.Cp2m }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="中子模式3" prop="Cp3m">
              {{ data.Cp3m }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="中子模式4" prop="Cp4m">
              {{ data.Cp4m }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="中子进位置1" prop="Cpt1s">
              {{ data.Cpt1s }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="中子进位置2" prop="Cpt2s">
              {{ data.Cpt2s }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="中子进位置3" prop="Cpt3s">
              {{ data.Cpt3s }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="中子进位置4" prop="Cpt4s">
              {{ data.Cpt4s }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="中子进压力1" prop="Cpi1p">
              {{ data.Cpi1p }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="中子进压力2" prop="Cpi2p">
              {{ data.Cpi2p }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="中子进压力3" prop="Cpi3p">
              {{ data.Cpi3p }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="中子进压力4" prop="Cpi4p">
              {{ data.Cpi4p }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="中子进速度1" prop="Cpi1v">
              {{ data.Cpi1v }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="中子进速度2" prop="Cpi2v">
              {{ data.Cpi2v }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="中子进速度3" prop="Cpi3v">
              {{ data.Cpi3v }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="中子进速度4" prop="Cpi4v">
              {{ data.Cpi4v }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="中子进时间1" prop="Cpi1t">
              {{ data.Cpi1t }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="中子进时间2" prop="Cpi2t">
              {{ data.Cpi2t }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="中子进时间3" prop="Cpi3t">
              {{ data.Cpi3t }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="中子进时间4" prop="Cpi4t">
              {{ data.Cpi4t }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="中子退位置1" prop="Cpo1s">
              {{ data.Cpo1s }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="中子退位置2" prop="Cpo2s">
              {{ data.Cpo2s }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="中子退位置3" prop="Cpo3s">
              {{ data.Cpo3s }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="中子退位置4" prop="Cpo4s">
              {{ data.Cpo4s }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="中子退压力1" prop="Cpo1p">
              {{ data.Cpo1p }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="中子退压力2" prop="Cpo2p">
              {{ data.Cpo2p }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="中子退压力3" prop="Cpo3p">
              {{ data.Cpo3p }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="中子退压力4" prop="Cpo4p">
              {{ data.Cpo4p }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="中子退速度1" prop="Cpo1v">
              {{ data.Cpo1v }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="中子退速度2" prop="Cpo2v">
              {{ data.Cpo2v }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="中子退速度3" prop="Cpo3v">
              {{ data.Cpo3v }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="中子退速度4" prop="Cpo4v">
              {{ data.Cpo4v }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="中子退时间1" prop="Cpo1t">
              {{ data.Cpo1t }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="中子退时间2" prop="Cpo2t">
              {{ data.Cpo2t }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="中子退时间3" prop="Cpo3t">
              {{ data.Cpo3t }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="中子退时间4" prop="Cpo4t">
              {{ data.Cpo4t }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="座进压力1" prop="Cfp1">
              {{ data.Cfp1 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="座进压力2" prop="Cfp2">
              {{ data.Cfp2 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="座进速度1" prop="Cfv1">
              {{ data.Cfv1 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="座进速度2" prop="Cfv2">
              {{ data.Cfv2 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="座进位置1" prop="Cfs1">
              {{ data.Cfs1 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="座进位置2" prop="Cfs2">
              {{ data.Cfs2 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="座进时间1" prop="Cft1">
              {{ data.Cft1 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="座进时间2" prop="Cft2">
              {{ data.Cft2 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="座退压力" prop="Cbp1">
              {{ data.Cbp1 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="座退速度" prop="Cbv1">
              {{ data.Cbv1 }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="座退位置" prop="Cbs1">
              {{ data.Cbs1 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="座退时间" prop="Cbt1">
              {{ data.Cbt1 }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="座退延迟时间" prop="Cbdt1">
              {{ data.Cbdt1 }}
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <template>
          <el-button @click="close">关 闭</el-button>
        </template>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog
  },
  props: {
    type: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      api: require('@/api/equipment/craftdata').default,
      data: {
        OrderNo: '',
        WorkDocNo: '',
        ProductName: '',
        MouldName: '',
        Ts1: null,
        Ts2: null,
        Ts3: null,
        Ts4: null,
        Ts5: null,
        Ts6: null,
        Ts7: null,
        Ts8: null,
        Ts9: null,
        Ts10: null,

        Ip1: null,
        Ip2: null,
        Ip3: null,
        Ip4: null,
        Ip5: null,
        Ip6: null,
        Ip7: null,
        Ip8: null,
        Ip9: null,
        Ip10: null,

        Iv1: null,
        Iv2: null,
        Iv3: null,
        Iv4: null,
        Iv5: null,
        Iv6: null,
        Iv7: null,
        Iv8: null,
        Iv9: null,
        Iv10: null,

        Is1: null,
        Is2: null,
        Is3: null,
        Is4: null,
        Is5: null,
        Is6: null,
        Is7: null,
        Is8: null,
        Is9: null,
        Is10: null,

        It1: null,
        It2: null,
        It3: null,
        It4: null,
        It5: null,
        It6: null,
        It7: null,
        It8: null,
        It9: null,
        It10: null,

        Ituse: null,
        Isuse: null,
        Sipt: null,
        Sips: null,
        Sipp: null,

        Pp1: null,
        Pp2: null,
        Pp3: null,
        Pp4: null,
        Pp5: null,
        Pp6: null,
        Pp7: null,
        Pp8: null,
        Pp9: null,
        Pp10: null,

        Pv1: null,
        Pv2: null,
        Pv3: null,
        Pv4: null,
        Pv5: null,
        Pv6: null,
        Pv7: null,
        Pv8: null,
        Pv9: null,
        Pv10: null,

        Pt1: null,
        Pt2: null,
        Pt3: null,
        Pt4: null,
        Pt5: null,
        Pt6: null,
        Pt7: null,
        Pt8: null,
        Pt9: null,
        Pt10: null,

        Sbs1: null,
        Sbt1: null,
        Pllt: null,

        Plv1: null,
        Plv2: null,
        Plv3: null,
        Plv4: null,
        Plv5: null,
        Plv6: null,
        Plv7: null,
        Plv8: null,
        Plv9: null,
        Plv10: null,

        Plp1: null,
        Plp2: null,
        Plp3: null,
        Plp4: null,
        Plp5: null,
        Plp6: null,
        Plp7: null,
        Plp8: null,
        Plp9: null,
        Plp10: null,

        Plbp1: null,
        Plbp2: null,
        Plbp3: null,
        Plbp4: null,
        Plbp5: null,
        Plbp6: null,
        Plbp7: null,
        Plbp8: null,
        Plbp9: null,
        Plbp10: null,

        Pls1: null,
        Pls2: null,
        Pls3: null,
        Pls4: null,
        Pls5: null,
        Pls6: null,
        Pls7: null,
        Pls8: null,
        Pls9: null,
        Pls10: null,

        Sbv2: null,
        Sbp2: null,
        Sbs2: null,
        Sbt2: null,
        Ct: null,

        Mcv1: null,
        Mcv2: null,
        Mcv3: null,
        Mcv4: null,
        Mcv5: null,
        Mcv6: null,
        Mcv7: null,
        Mcv8: null,
        Mcv9: null,
        Mcv10: null,

        Mcp1: null,
        Mcp2: null,
        Mcp3: null,
        Mcp4: null,
        Mcp5: null,
        Mcp6: null,
        Mcp7: null,
        Mcp8: null,
        Mcp9: null,
        Mcp10: null,

        Mcs1: null,
        Mcs2: null,
        Mcs3: null,
        Mcs4: null,
        Mcs5: null,
        Mcs6: null,
        Mcs7: null,
        Mcs8: null,
        Mcs9: null,
        Mcs10: null,

        Mov1: null,
        Mov2: null,
        Mov3: null,
        Mov4: null,
        Mov5: null,
        Mov6: null,
        Mov7: null,
        Mov8: null,
        Mov9: null,
        Mov10: null,

        Mop1: null,
        Mop2: null,
        Mop3: null,
        Mop4: null,
        Mop5: null,
        Mop6: null,
        Mop7: null,
        Mop8: null,
        Mop9: null,
        Mop10: null,

        Mos1: null,
        Mos2: null,
        Mos3: null,
        Mos4: null,
        Mos5: null,
        Mos6: null,
        Mos7: null,
        Mos8: null,
        Mos9: null,
        Mos10: null,

        Efdt: null,
        Efv1: null,
        Efv2: null,
        Efv3: null,

        Efp1: null,
        Efp2: null,
        Efp3: null,

        Efs1: null,
        Efs2: null,
        Efs3: null,

        Ebdt: null,
        Ebv1: null,
        Ebv2: null,
        Ebv3: null,

        Ebp1: null,
        Ebp2: null,
        Ebp3: null,

        Ebs1: null,
        Ebs2: null,
        Ebs3: null,

        Cp1m: null,
        Cp2m: null,
        Cp3m: null,
        Cp4m: null,

        Cpt1s: null,
        Cpt2s: null,
        Cpt3s: null,
        Cpt4s: null,

        Cpi1p: null,
        Cpi2p: null,
        Cpi3p: null,
        Cpi4p: null,

        Cpi1v: null,
        Cpi2v: null,
        Cpi3v: null,
        Cpi4v: null,

        Cpi1t: null,
        Cpi2t: null,
        Cpi3t: null,
        Cpi4t: null,

        Cpo1s: null,
        Cpo2s: null,
        Cpo3s: null,
        Cpo4s: null,

        Cpo1p: null,
        Cpo2p: null,
        Cpo3p: null,
        Cpo4p: null,

        Cpo1v: null,
        Cpo2v: null,
        Cpo3v: null,
        Cpo4v: null,

        Cpo1t: null,
        Cpo2t: null,
        Cpo3t: null,
        Cpo4t: null,

        Cfp1: null,
        Cfp2: null,

        Cfv1: null,
        Cfv2: null,

        Cfs1: null,
        Cfs2: null,

        Cft1: null,
        Cft2: null,

        Cbp1: null,
        Cbv1: null,
        Cbs1: null,
        Cbt1: null,
        Cbdt1: null
      }
    }
  },
  methods: {
    onEditOpened() {}
  }
}
</script>
